module.exports = __webpack_public_path__ + "static/media/coffee-latte-dt-en.c204b7e0.mp4";